import { ModeSettingEnum } from '@colonist/game-base-types';
import { ClientUserState } from '../ClientUserState.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export class UISessionRecorder {
    async init() {
        if (!this.shouldRecordThisSession) return;
        if (this.highlightController != undefined) return;
        try {
            const highlight = await import('highlight.run');
            this.highlightController = highlight.H;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Failed to load highlight.run', e);
            this.shouldRecordThisSession = false;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    async conditionallyStartRecording(modeSetting) {
        if (modeSetting != ModeSettingEnum.ColonistRush4P) return;
    // TODO: Uncomment this when the canvas recording in highlight.io is fixed
    // await this.startRecording({context: 'ColonistRush'})
    }
    async startRecording(sessionIdentifiers) {
        var _ClientUserState_userState;
        await this.init();
        if (this.highlightController == undefined) return;
        this.highlightController.init(this.APP_ID, this.RECORDER_OPTIONS);
        this.highlightController.identify((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.id, {
            context: sessionIdentifiers.context
        });
    }
    stopRecording() {
        if (this.highlightController == undefined) return;
        this.highlightController.stop();
    }
    getShouldRecordThisSession() {
        if (!UIUtilsEjsVariables.isProduction) return false;
        const shouldRecordThisSession = Math.random() < this.RECORDING_LIMIT_PER_MONTH / this.OUR_CURRENT_USAGE;
        return shouldRecordThisSession;
    }
    constructor(){
        this.APP_ID = '1epp9p7e';
        this.FRAME_RATE = 5;
        this.RESOLUTION = 720;
        this.RECORDING_LIMIT_PER_MONTH = 500;
        this.AVG_BEGINNER_MODE_USERS_PER_MONTH = 16000;
        this.OUR_CURRENT_USAGE = this.AVG_BEGINNER_MODE_USERS_PER_MONTH // Add to this number as we use recorder in more places
        ;
        this.DISCORD_SCRIPT_PROXY_URL = '/.proxy/highlight-static/v8.9.1/index.js';
        this.DISCORD_BACKEND_PROXY_URL = '/.proxy/highlight-pub';
        this.RECORDER_OPTIONS = {
            enableCanvasRecording: true,
            samplingStrategy: {
                canvas: this.FRAME_RATE,
                canvasMaxSnapshotDimension: this.RESOLUTION
            },
            environment: UIUtilsEjsVariables.isProduction ? 'production' : 'test',
            version: UIUtilsEjsVariables.versionNumber.toString(),
            networkRecording: {
                enabled: true,
                recordHeadersAndBody: true,
                urlBlocklist: []
            },
            scriptUrl: UIUtilsEjsVariables.isUserOnDiscord ? this.DISCORD_SCRIPT_PROXY_URL : undefined,
            backendUrl: UIUtilsEjsVariables.isUserOnDiscord ? this.DISCORD_BACKEND_PROXY_URL : undefined
        };
        this.shouldRecordThisSession = this.getShouldRecordThisSession();
    }
}
